module.exports = __webpack_public_path__ + "img/156.1555dc29.jpg";